import { render, staticRenderFns } from "./SettingsBotSnippetJavaScript.vue?vue&type=template&id=547ee8e7&"
import script from "./SettingsBotSnippetJavaScript.vue?vue&type=script&lang=js&"
export * from "./SettingsBotSnippetJavaScript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports